export class InstaPromoLocalStorageModel {
    promoItemId: string;
    viewedTimeStamp: number;
}
